import { memo } from 'react';
import Head from 'next/head';
import { TripshockViatorProduct } from '@/entities/Viator/domain/Viator.domain';

type VActivityMetaProps = {
    product: TripshockViatorProduct;
    url: string;
    imageUrl?: string;
};

const stripHtml = (html: string): string => {
    if (typeof window === 'undefined') return html.substring(0, 160);
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || '';
    return text.substring(0, 160);
};

const VActivityMetaComponent = ({ product, url, imageUrl }: VActivityMetaProps): JSX.Element => {
    const rootUrl = url || '';
    const description = stripHtml(product.description);

    return (
        <Head>
            <title>{product.title}</title>
            <meta name="description" key="description" content={description} />
            {typeof rootUrl === 'string' && <link rel="canonical" key="canonical" href={rootUrl} />}
            {typeof rootUrl === 'string' && <meta property="og:url" content={rootUrl} />}
            <meta property="og:title" content={product.title} />
            <meta property="og:description" content={description} />
            {imageUrl && <meta property="og:image" content={imageUrl} />}
            {imageUrl && <meta property="og:image:width" content="1080" />}
            {imageUrl && <meta property="og:image:height" content="1080" />}
            <meta property="og:type" content="website" />
        </Head>
    );
};

export const VActivityMeta = memo(VActivityMetaComponent);
